(() => {
  'use strict';

  if (window.__bellkmartKachingBundlePriceSyncLoaded) return;
  window.__bellkmartKachingBundlePriceSyncLoaded = true;

  const bundleRootSelector = 'kaching-bundles-block, .kaching-bundles__block';
  const bundleBarSelector = '.kaching-bundles__bar, [data-kaching-bundle], [role="radio"]';
  const selectedBarSelector = [
    '.kaching-bundles__bar--selected',
    '.kaching-bundles__bar.selected',
    '[data-selected="true"]',
    '[aria-checked="true"]',
  ].join(', ');
  const bundleTitleSelector = '.kaching-bundles__bar-title';

  let activeBundleRoot = null;
  let bundleObserver = null;
  let updateQueued = false;

  function extractPrice(text) {
    if (!text) return null;

    const normalized = text.replace(/\u00a0/g, ' ').trim();
    const symbolPrice = normalized.match(
      /(?:US\$|CA\$|AU\$|NZ\$|HK\$|S\$|\$)\s*\d[\d,]*(?:[.,]\d{1,2})?/i
    );
    const currencyCodePrice = normalized.match(
      /\d[\d,]*(?:[.,]\d{1,2})?\s*(?:USD|CAD|AUD|NZD|EUR|GBP|JPY|CNY|RMB|HKD|SGD)/i
    );
    const match = symbolPrice || currencyCodePrice;

    return match ? match[0].replace(/\$\s+/, '$').trim() : null;
  }

  function findSelectedBar(root) {
    const checkedInput = root.querySelector('input[type="radio"]:checked');
    if (checkedInput) {
      return checkedInput.closest(bundleBarSelector) || checkedInput.parentElement;
    }

    return root.querySelector(selectedBarSelector);
  }

  function getSelectedBundlePrice(root) {
    const selectedBar = findSelectedBar(root);
    const selectedTitle = selectedBar?.querySelector(bundleTitleSelector);

    if (selectedTitle) return extractPrice(selectedTitle.textContent);

    const titles = root.querySelectorAll(bundleTitleSelector);
    return titles.length === 1 ? extractPrice(titles[0].textContent) : null;
  }

  function getMainPriceRoot(root) {
    const productInfo = root.closest('product-info') || document.querySelector('product-info[id^="MainProduct-"]');
    if (!productInfo) return null;

    const sectionId = productInfo.dataset.section;
    return sectionId ? document.getElementById(`price-${sectionId}`) : productInfo.querySelector('[id^="price-"]');
  }

  function syncSelectedBundlePrice() {
    updateQueued = false;

    const root = document.querySelector(bundleRootSelector);
    if (!root) return;

    bindBundleRoot(root);

    const selectedPrice = getSelectedBundlePrice(root);
    const priceRoot = getMainPriceRoot(root);
    if (!selectedPrice || !priceRoot) return;

    const sellingPriceNodes = priceRoot.querySelectorAll(
      '.price__sale .price-item--sale.price-item--last, .price__regular .price-item--regular:not(.variant-item__old-price)'
    );

    sellingPriceNodes.forEach((node) => {
      if (node.textContent.trim() !== selectedPrice) node.textContent = selectedPrice;
    });
  }

  function queuePriceSync() {
    if (updateQueued) return;
    updateQueued = true;
    window.requestAnimationFrame(syncSelectedBundlePrice);
  }

  function bindBundleRoot(root) {
    if (root === activeBundleRoot) return;

    bundleObserver?.disconnect();
    activeBundleRoot = root;
    bundleObserver = new MutationObserver(queuePriceSync);
    bundleObserver.observe(root, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'checked', 'aria-checked', 'data-selected'],
    });
  }

  document.addEventListener('click', (event) => {
    const root = event.target.closest?.(bundleRootSelector);
    if (!root) return;

    bindBundleRoot(root);
    queuePriceSync();
    window.setTimeout(queuePriceSync, 80);
    window.setTimeout(queuePriceSync, 250);
  });

  document.addEventListener('change', (event) => {
    if (event.target.closest?.(bundleRootSelector)) queuePriceSync();
  });

  document.addEventListener('shopify:section:load', queuePriceSync);

  const pageObserver = new MutationObserver((mutations) => {
    const shouldSync = mutations.some((mutation) => {
      const target = mutation.target.nodeType === Node.ELEMENT_NODE ? mutation.target : mutation.target.parentElement;
      if (target?.closest?.('product-info')) return true;

      return Array.from(mutation.addedNodes).some(
        (node) =>
          node.nodeType === Node.ELEMENT_NODE &&
          (node.matches?.(bundleRootSelector) || node.querySelector?.(bundleRootSelector))
      );
    });

    if (shouldSync) queuePriceSync();
  });

  function initialize() {
    pageObserver.observe(document.body, { subtree: true, childList: true });
    queuePriceSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
